import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-296fd47c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-gouwuche",
  style: {"font-size":"15px","margin-right":"4px","display":"inline-block","vertical-align":"bottom"}
}, null, -1))

import { ref, computed } from 'vue'
import { bury } from '@/util/useBury'
import { useRouter } from 'vue-router'
import { lastCart } from '@/apis/shopcart'
import { t } from '@/plugins/i18n'
import { useRtfix } from '@/store'
import SvgIcon from '@/components/icons/SvgIcon.vue'
import { useStore } from 'vuex'
import { TaEvent, taTrack } from '@/util/buryingPoint'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()

const router = useRouter()
const isLogin = computed(() => store.getters.isLogin)
const num: any = computed(() => store.state.message.cart)
const set = () => {
  // 登录请求
  if (isLogin.value) {
    lastCart().then((res) => {
      if (res.success) {
        store.commit('message/cart', Number(res.data.cartSummary.sumCartProductQuantity))
        store.commit('message/cartSummaryDTOList', res.data.cartSummaryDTOList)
      }
    })
  }
}
set()
store.dispatch('message/subscrible', ['cart', set])
store.dispatch('message/subscrible', ['message', () => {
  if (isLogin.value) {
    store.dispatch('message/getMessageNum')
  }
}])

const gotoCart = () => {
  taTrack({
    event: TaEvent.BTN_CLICK,
    value: {
      position: 'shopping_cart'
    }
  })
  if (!store.getters.isLogin) {
    taTrack({
      event: TaEvent.PUPUP_WINDOW,
      value: {
        position: 'login',
        source: 'shopping_cart'
      }
    })
  }
  router.push(useRtfix('shopcart'))
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(_component_el_button, {
    class: "rel",
    type: "default",
    onClick: gotoCart
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createTextVNode(" " + _toDisplayString(_unref(t)('购物车')) + " ", 1),
      _withDirectives(_createElementVNode("span", { class: "abs cart-num" }, _toDisplayString(_unref(num) > 99 ? '99+' : _unref(num)), 513), [
        [_vShow, _unref(num) !== 0]
      ])
    ]),
    _: 1
  }))
}
}

})